export default "__VITE_ASSET__KGLE9soX__"